import React, { useState } from 'react';
import { SimpleGrid, Stack, Flex, InputGroup } from '@chakra-ui/react';
import CompartmentCard from './CompartmentCard';
import { Search } from "lucide-react"; 
import NoDataFound from 'components/NoDataGraphics/NoDataFound';
import ReusableInput from 'components/Inputs/ReusableInput';
import { useLocation, useHistory } from 'react-router-dom';
import GradientButton from 'components/Buttons/GradientButton';

const CompartmentPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { compartments, lockerLocation } = location.state || {}; // Fetch compartments from route state
  const [searchTerm, setSearchTerm] = useState('');

  // Filter compartments based on the search term
  const filteredCompartments = compartments?.filter(compartment =>
    compartment.compartment_id.toLowerCase().includes(searchTerm.toLowerCase())
  ) || [];

  return (
    <Stack spacing={5} p={5} mt={20}>
      <Flex justifyContent="space-between" alignItems="center">
        <InputGroup width="300px" ml={5} borderRadius="12px">
          <ReusableInput
            icon={<Search size={20} color="#A0AEC0" />}
            placeholder="Search by Compartment ID"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
        <GradientButton onClick={() => history.goBack()} height="40px" mr={5}>
          Back to Lockers
        </GradientButton>
      </Flex>
      
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 4 }} spacing={5} p={5} mt={20}>
        {filteredCompartments.map((compartment) => (
          <CompartmentCard key={compartment.compartment_id} {...compartment} />
        ))}
      </SimpleGrid>

      {filteredCompartments.length === 0 && (
        <Flex justifyContent="center" alignItems="center" height="300px" width="100%">
          <NoDataFound message="No compartments found matching your search." />
        </Flex>
      )}
    </Stack>
  );
};

export default CompartmentPage;
